import "core-js/modules/es6.regexp.search";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import Fuse from 'fuse.js';
// tslint:disable:no-console

/**
 * # How to use
 *
 * 1. Call `buildIndex` (sending your search data)
 * 2. Call `search`
 *
 */
////////////////////////////////////////////////////////////////////////////////////////////////////
var searchIndex;
/**
 * builds the overall index based on the options
 */

export function buildIndex(indexParams) {
  searchIndex = new Fuse(indexParams.data, {
    shouldSort: indexParams.shouldSort || true,
    tokenize: indexParams.tokenize || true,
    threshold: indexParams.threshold || 0.4,
    maxPatternLength: indexParams.maxPatternLenght || 32,
    minMatchCharLength: indexParams.minMatchCharLength || 1,
    keys: indexParams.keys
  });
}
/**
 *
 * @param term  the term to be search
 */

export function search(term) {
  if (!searchIndex) {
    return null;
  }

  var result = searchIndex.search(term);
  return result;
}
addEventListener('message', function (e) {var ref = e.data;var type = ref.type;var method = ref.method;var id = ref.id;var params = ref.params;var f,p;if (type === 'RPC' && method) {if (f = __webpack_exports__[method]) {p = Promise.resolve().then(function () { return f.apply(__webpack_exports__, params); });} else {p = Promise.reject('No such method');}p.then(function (result) {postMessage({type: 'RPC',id: id,result: result});}).catch(function (e) {var error = {message: e};if (e.stack) {error.message = e.message;error.stack = e.stack;error.name = e.name;}postMessage({type: 'RPC',id: id,error: error});});}});postMessage({type: 'RPC',method: 'ready'});